"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _STORAGE_KEYS = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/constants/app/STORAGE_KEYS"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns current language
 * Reads from cookie
 * runs only on client side
 */
function getCurrentLanguage() {
  var isClient = typeof window !== 'undefined';
  return isClient && (document.documentElement.lang || _jsCookie["default"].get(_STORAGE_KEYS["default"].LANG_COOKIE));
}
var _default = exports["default"] = getCurrentLanguage;